<template>
  <v-card flat :color="color" tile min-height="40" class="ma-0 pa-0">
    <v-card-text class="ma-0 pa-0">
      <v-combobox
        v-model="term_chips"
        small-chips
        :rounded="rounded"
        :solo="solo"
        clearable
        outlined
        dense
        label="Enter tab separated keywords"
        multiple
        small
        ref="keywords"
        append-outer-icon="mdi-magnify"
        :dark="dark"
        @click:append-outer="search()"
        @click:clear="clearSearch()"
      >
        <template v-slot:selection="{ attrs, item, select, selected }">
          <v-chip
            color="rgb(255, 20, 99)"
            small
            label
            v-bind="attrs"
            :input-value="selected"
            close
            @click="select"
            @click:close="remove_kw(item)"
            >{{ item }}</v-chip
          >
        </template>
      </v-combobox>
    </v-card-text>
  </v-card>
</template>

<script>
import { getArray } from "./Utils.js";
import { autocomplete, fetchProfile } from "./APIManager.js";

export default {
  props: {
    rounded: Boolean,
    solo: Boolean,
    dark: Boolean,
    color: String
  },
  data() {
    return {
      term_chips: [],
      search_terms: "",
      items: [],
      isLoading: false,
      disable_nav: false,
      lookup_limit: 60,
      entity: {}
      //show_login_menu: false
    };
  },

  watch: {
    search_terms(val) {
      val && val !== this.select && this.lookup(val);
    }
  },

  mounted() {

    var query = this.$route.query;

    if (query.hasOwnProperty("term")) {
      this.term_chips = getArray(query["term"]);
    }

  },

  methods: {
    
    remove_kw(item) {
      this.term_chips.splice(this.term_chips.indexOf(item), 1);
      this.term_chips = [...this.term_chips];
      if (this.term_chips.length == 0){
        this.clearSearch()
      }
    },

    clearSearch() {
      this.term_chips = [];
      this.$emit("clearFilter", true);

    },

    search(){
      ////////////console.log("IN SEARCH for: ", this.entity.key);
    
      if (this.term_chips.length > 0) {

         var qry = JSON.parse(JSON.stringify(this.$route.query));
         delete qry["term"];
         delete qry["page"];
         var page_num = 1;
         this.$router.push({ name: 'categories', query: {...this.$route.query, term: this.term_chips, page: page_num }});
      }

    },

    getCategory(category_id) {
      this.$emit("close-entity-menu");
      this.$router.push({ name: "category", params: { id: category_id } });
    },

    lookup(terms) {
      // Lazily load input items
      this.isLoading = true;
      autocomplete(this.search_terms, "category")
        .then(data => {
          data.unshift({ key: terms }); 
          this.items = data;
        })
        .finally(() => (this.isLoading = false));
    },

    disabled() {
      if (localStorage.getItem("isLoggedIn") == "1") {
        this.disable_nav = false;
        return this.disable_nav;
      } else {
        this.disable_nav = true;
        return this.disable_nav;
      }
    }
  }
};
</script>
